<template>
    <div>
      <div style="margin-top: 5px">
        <el-button size="mini" @click="excel">当期+历史收缴率</el-button>
        <el-button size="mini" @click="excel2">当期收缴率</el-button>
        <el-button size="mini" @click="excel3">战区收缴率</el-button>
      </div>
      <el-descriptions :column="2" size="mini" border style="margin-top: 8px">
        <el-descriptions-item label="项目">
          <el-select
            v-model="pid"
            size="mini"
            multiple
            collapse-tags
            filterable
            style="width: 70%"
            placeholder="选择项目"
          >
            <el-option
              v-for="item in projecta"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <span style="cursor: pointer" @click="completeProject">全选</span>
          <span style="margin-left: 3px; cursor: pointer" @click="cancelProject"
            >取消</span
          >
        </el-descriptions-item>
        <el-descriptions-item label="战区">
          <el-select
            v-model="zoneIds"
            size="mini"
            multiple
            collapse-tags
            filterable
            style="width: 70%"
            placeholder="选择战区"
          >
            <el-option
              v-for="item in zones"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <span style="cursor: pointer" @click="completeZone">全选</span>
          <span style="margin-left: 3px; cursor: pointer" @click="cancelZone"
            >取消</span
          >
        </el-descriptions-item>
        <el-descriptions-item label="收费项目">
          <el-select
            v-model="form.chargeitemID"
            size="mini"
            multiple
            filterable
            collapse-tags
            style="width: 50%"
            placeholder="收费项目"
          >
            <el-option
              v-for="item in chargeitem"
              :key="item.id"
              :label="item.chargeItem_name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="计费周期">
          <el-date-picker
            v-model="startDate"
            size="mini"
            type="date"
            format="yyyy-MM-dd"
            value-format="timestamp"
            placeholder="选择开始日期"
          />
          至
          <el-date-picker
            v-model="endDate"
            size="mini"
            type="date"
            format="yyyy-MM-dd"
            value-format="timestamp"
            placeholder="选择结束日期"
          />
        </el-descriptions-item>
        <el-descriptions-item label="缴款时间">
          <el-date-picker
            v-model="payStartDate"
            size="mini"
            type="date"
            format="yyyy-MM-dd"
            value-format="timestamp"
            placeholder="选择开始日期"
          />
          至
          <el-date-picker
            v-model="payEndDate"
            size="mini"
            type="date"
            format="yyyy-MM-dd"
            value-format="timestamp"
            placeholder="选择结束日期"
          />
        </el-descriptions-item>
      </el-descriptions>
      <excel-task
        ref="ExcelTask"
        :excelTask="excelTask"
        :excelTaskId="excelTaskId"
        @close="closeExcelTask"
      />
    </div>
  </template>
  
  <script>
  import ErpTree from "@/components/Admin/Common/erp-tree";
  import ExcelTask from "@/components/common/excelTask";
  export default {
    name: "PaymentRateStatement",
    components: {
      ErpTree,
      ExcelTask,
    },
    data() {
      return {
        form: {
          chargeitemID: [],
          startDate: "",
          endDate: "",
          payStartDate: "",
          payEndDate: "",
        },
        pid: [],
        zoneIds: [],
        startDate: "",
        endDate: "",
        payStartDate: "",
        payEndDate: "",
        chargeitem: [],
        excelTaskId: null,
        excelTask: false,
        projecta: [],
        zones: [],
      };
    },
    mounted() {
      //加载收费大类（费项）
      this.$myhttp
        .get("admin/common/getChargeitem", {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          this.chargeitem = backdata.data.data;
        });
      this.projects();
      this.zone();
    },
    methods: {
      excel() {
        let form = this.form;
        form.pid = this.pid;
        form.zoneIds = this.zoneIds;
        form.startDate = this.startDate / 1000;
        form.endDate = this.endDate / 1000;
        form.payStartDate = this.payStartDate / 1000;
        form.payEndDate = this.payEndDate / 1000;
        form.targetController = "FinancialAgeAnalysisStatement";
        form.targetFunction = "excel3";
        form.taskName = "当期+历史项目收缴率";
        ERP.showLoading();
        this.$myhttp
          .post("admin/ExcelTask/addTask", form, {
            "Content-Type": "application/x-www-form-urlencoded",
          })
          .then((backdata) => {
            // 异步执行成功后
            ERP.hideLoading();
            this.$store.commit("excelTaskAdd");
            this.$Message.success("导出任务已创建!");
            var data = backdata.data.data;
            this.excelTaskId = data.excelTaskId;
            this.openExcelTask();
          });
      },
      excel2() {
        let form = this.form;
        form.pid = this.pid;
        form.zoneIds = this.zoneIds;
        form.targetController = "FinancialAgeAnalysisStatement";
        form.targetFunction = "excel4";
        form.startDate = this.startDate / 1000;
        form.endDate = this.endDate / 1000;
        form.payStartDate = this.payStartDate / 1000;
        form.payEndDate = this.payEndDate / 1000;
        form.taskName = "项目收缴率(当期)";
        ERP.showLoading();
        this.$myhttp
          .post("admin/ExcelTask/addTask", form, {
            "Content-Type": "application/x-www-form-urlencoded",
          })
          .then((backdata) => {
            // 异步执行成功后
            ERP.hideLoading();
            this.$store.commit("excelTaskAdd");
            this.$Message.success("导出任务已创建!");
            var data = backdata.data.data;
            this.excelTaskId = data.excelTaskId;
            this.openExcelTask();
          });
      },
      excel3() {
        let form = this.form;
        form.pid = this.pid;
        form.zoneIds = this.zoneIds;
        form.targetController = "FinancialAgeAnalysisStatement";
        form.targetFunction = "excel5";
        form.startDate = this.startDate / 1000;
        form.endDate = this.endDate / 1000;
        form.payStartDate = this.payStartDate / 1000;
        form.payEndDate = this.payEndDate / 1000;
        form.taskName = "战区收缴率";
        ERP.showLoading();
        this.$myhttp
          .post("admin/ExcelTask/addTask", form, {
            "Content-Type": "application/x-www-form-urlencoded",
          })
          .then((backdata) => {
            // 异步执行成功后
            ERP.hideLoading();
            this.$store.commit("excelTaskAdd");
            this.$Message.success("导出任务已创建!");
            var data = backdata.data.data;
            this.excelTaskId = data.excelTaskId;
            this.openExcelTask();
          });
      },
      openExcelTask() {
        this.$store.commit("excelTaskClear");
        this.excelTask = true;
        this.$refs.ExcelTask.change(1);
      },
      closeExcelTask() {
        this.excelTask = false;
      },
      //名下项目
      projects() {
        this.$myhttp
          .get("admin/common/pindex", {
            "Content-Type": "application/json",
          })
          .then((backdata) => {
            // 异步执行成功后
            this.projecta = backdata.data.data;
          });
      },
      completeProject() {
        let data = this.projecta;
        let ids = [];
        data.map((req) => {
          ids.push(req.id);
        });
        this.pid = ids;
      },
      //取消
      cancelProject() {
        this.pid = [];
      },
      //名下战区
      zone() {
        this.$myhttp
          .post(
            "admin/ZoneManage/index",
            { type: 1, pageSize: 50 },
            {
              "Content-Type": "application/json",
            }
          )
          .then((backdata) => {
            // 异步执行成功后
            this.zones = backdata.data.data;
          });
      },
      completeZone() {
        let data = this.zones;
        let ids = [];
        data.map((req) => {
          ids.push(req.id);
        });
        this.zoneIds = ids;
      },
      //取消
      cancelZone() {
        this.zoneIds = [];
      },
    },
  };
  </script>
  
  <style>
  </style>


// WEBPACK FOOTER //
// src/components/Admin/Forms/paymentRateStatement.vue